import { FEATURE } from '~/common/enums/feature.enum';
import { useTreatments } from '~/domains/common/hooks/useTreatments';

export const useEnableEditContest = () => {
  const editContestEnabled = useTreatments([FEATURE.ENABLE_EDIT_CONTEST]);
  const isEditContestEnabled =
    editContestEnabled?.treatments[FEATURE.ENABLE_EDIT_CONTEST].treatment === 'on';
  const isEditContestReady = editContestEnabled?.isReady;

  return {
    isEditContestEnabled,
    isEditContestReady,
  };
};
